import { createContext, useContext } from "react";

import useMyAgencyData from "./useMyAgencyData";
import useUserData from "./useUserData";
// import { toast } from "~/utils/toast";

type BedFinderGroupAccess =
  | "bedfinder:canAnswerRequest"
  | "bedfinder:canReceiveRequest"
  | "bedfinder:canSendRequest"
  | "bedfinder:collaboratives";
export type FeatureTag =
  | "ssc-portal"
  | "bedfinder"
  | "safenight"
  | BedFinderGroupAccess;
type Features = Array<FeatureTag>;

const FeaturesContext = createContext<Features>([]);

export function useFeature(feature: FeatureTag) {
  const features = useContext(FeaturesContext);
  return features.includes(feature);
}


export function useCanAswer(groupId: string[]) {
  const myShelter = useMyAgencyData();
  return myShelter?.groupInfo?.find(
    it => groupId.includes(it.groupId) && it.canAnswerRequest,
  );
}

export function FeaturesProvider({ children }: { children: React.ReactNode }) {
  const myShelter = useMyAgencyData();
  const me = useUserData();
  const features: Record<FeatureTag, boolean | undefined> = {
    "ssc-portal": true,
    bedfinder: myShelter?.namespace.includes("bedfinder"),
    safenight: myShelter?.namespace.includes("safenight"),
    "bedfinder:canAnswerRequest": myShelter?.groupInfo?.some(
      it => it.canAnswerRequest,
    ),
    "bedfinder:canReceiveRequest": myShelter?.groupInfo?.some(
      it => it.canReceiveRequest,
    ),
    "bedfinder:canSendRequest": myShelter?.groupInfo?.some(
      it => it.canSendRequest,
    ),
    "bedfinder:collaboratives": me?.features?.collaboratives,
  };

  const enabledFeatures = Object.keys(features).filter(
    (tag): tag is FeatureTag => !!features[tag as FeatureTag],
  );

  return (
    <FeaturesContext.Provider value={enabledFeatures}>
      {children}
    </FeaturesContext.Provider>
  );
}

export function Guard({
  feature,
  disabled,
  message,
  children,
}: {
  feature: FeatureTag;
  disabled?: boolean;
  message?: string;
  children: React.ReactNode;
}) {
  const hasFeature = useFeature(feature);

  const handlePreventAction = (e: React.MouseEvent | React.TouchEvent) => {
    if (message) {
      // showToast(message, "error");
    }

    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  return hasFeature ? (
    <>{children}</>
  ) : disabled ? (
    <span onMouseDown={handlePreventAction} onTouchStart={handlePreventAction}>
      {children}
    </span>
  ) : null;
}
